import { IUserSeriesDetail, IRecommendedSeries } from '@ifit/gateway-wolf-dashboard-service';
import RowHeading from '../row-heading';
import { useUserType } from '../../state-management/selectors/use-user-type';
import { useRecommendedSeries } from '../../state-management/server-state/use-recommended-series';
import { useUserSeriesDetails } from '../../state-management/server-state/use-user-series-details';
import { Text } from './text';
import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import CardSeries from '../cards/series';
import { intensityConverter } from '../../util/intensity';
import { GlobalText } from '../../i18n/global-text';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import './index.scss';

export interface IRecommendedSeriesAndDetails {
  series: IRecommendedSeries;
  userSeriesDetail: IUserSeriesDetail;
}

export default function RecommendedSeriesRow(): JSX.Element {
  const isMatrixCommerical = useMatrixCommercial();
  const favoritesQuery = useRecommendedSeries(false);
  const { data } = favoritesQuery;

  const seriesIds = data?.map((series) => series.seriesId);
  const userSeriesDetailsQuery = useUserSeriesDetails(seriesIds);

  const zippedData: IRecommendedSeriesAndDetails[] = data?.map((series) => {
    return {
      series,
      userSeriesDetail: userSeriesDetailsQuery.data?.find((detail) => detail.seriesId === series.seriesId),
    };
  });

  const isAnonymous = useUserType() === 'anonymous';
  const isFetching = favoritesQuery.isFetching || userSeriesDetailsQuery.isFetching;
  const noValidData = !zippedData || zippedData.length === 0;
  const hideRow = isAnonymous || noValidData || isMatrixCommerical;

  if (hideRow) {
    return null;
  }

  return (
    <div className="row-recommended-series">
      <RowHeading title={Text.title} fetching={isFetching} />
      <div className="cards" style={{ ['--cards-per-row' as any]: zippedData?.length }}>
        {zippedData.map((item) => {
          const clickHandler = getUserNavigationHandler(item.series.navigationUrl, ROWTITLES.RECOMMENDED_SERIES_ITEM);
          const { userSeriesDetail, series } = item;
          const { imageUrl, intensity, seriesId, averageRating, title, workoutsCount } = series;
          const formattedRating = averageRating ? `${parseFloat(averageRating)}` : null;

          return (
            <CardSeries
              key={seriesId}
              onClick={clickHandler}
              imageUrl={imageUrl}
              tagPrimary={GlobalText.numberOfWorkouts(workoutsCount)}
              leadLine={intensityConverter(intensity)}
              averageRating={formattedRating}
              title={title}
              completed={userSeriesDetail?.completedDate}
              locked={userSeriesDetail?.locked}
            />
          );
        })}
      </div>
    </div>
  );
}
